<template>
<span class="surveillance-export-modal">
  <btn @click="exportAll" type="warning"
       disabled
       v-tooltip="`Cette fonctionalité est désactivée, si vous en avez
               besoin, demandez au développeur !`">
    Export csv avec fiche établissement
  </btn>
  <save-blob :target="csv.target"></save-blob>
  <modal v-model="show"
         size="lg"
         :backdrop="false"
         :keyboard="false"
         :footer="false"
         :header="false">
    <div class="export-modal">
      <div class="row">
        <div class="col-xs-12">
          <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
        </div>
      </div>
      <div v-if="completed">
        <btn @click="hide" type="default">Retour</btn>
      </div>
    </div>
  </modal>
</span>
</template>

<script>
import stringify from 'csv-stringify'
import StepIterator from '@/sui/tools/stepiterator'
import stepsViewer from '@/sui/components/steps'
import saveBlob from '@/sui/components/saveblob'
import impl from '@/components/surveillance/impl/exportmodal'

export default {
  name: 'surveillance-export-modal',

  props: {
    list: Array
  },

  data: function () {
    const steps = [
      {
        title: 'Récupération des fiches établissements',
        error: null,
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.error = null
            data.source = vm.list
            const reducer = (result, s) => {
              result.push(s.id)
              return result
            }
            data.ids = vm.list.reduce(reducer, [])
            const instance = this
            vm.$store.dispatch('denominatorsList/full', { s: data.ids }).then(
              (response) => {
                if (response.data.err == null) {
                  data.full = response.data.v
                } else {
                  instance.error = response.data.err
                }
              }
            ).catch(e => { instance.error = e })
          }

          return {
            end: data.full != null || this.error != null,
            success: this.error == null
          }
        },
        setError: function (e) {
          return `Erreur lors de la récupération des fiches établissement : ${e}.`
        }
      },

      {
        title: 'Récupération des compteurs de fiches',
        error: null,
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.error = null
            const instance = this
            vm.$store.dispatch('bosheet/summary', { s: data.ids }).then(
              (response) => {
                if (response.data.err == null) {
                  data.counts = response.data.v
                } else {
                  instance.error = response.data.err
                }
              }
            ).catch(e => { instance.error = e })
          }

          return {
            end: data.counts != null || this.error != null,
            success: this.error == null
          }
        },
        setError: function (e) {
          return `Erreur lors de la récupération des compteurs de fiches : ${e}.`
        }
      },

      {
        title: 'Fusion des inscriptions et des fiches établissement',
        index: 0,

        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.index = 0
            data.out = []
          }
          const max = data.source.length
          const step = 100
          const end = this.index + step >= max ? max : this.index + step
          for (let i = this.index; i !== end; ++i) {
            const s = data.source[i]
            const deno = data.full.find(d => d.sv === s.id)
            const c = data.counts.filter(c => c.s === s.id)
            data.out.push(impl.createExportedSurveillance(s, deno, c))
          }
          this.index = end

          return {
            end: this.index === max,
            success: true
          }
        },

        setError: function (e) {
          return `Erreur lors de la fusion inscription / fiche établissement: ${e}.`
        }
      },

      {
        title: 'Export du fichier',
        end: false,
        success: false,

        run: function (vm, data, iteration) {
          const instance = this
          if (iteration === 0) {
            this.end = false
            this.success = false
            this.output = null
            stringify(
              data.out,
              {
                header: true,
                bom: true,
                delimiter: ';',
                cast: impl.cast,
                columns: impl.columns
              },
              function (err, output) {
                if (err != null) {
                  instance.end = true
                  instance.success = false
                  instance.errorDetail = err
                  instance.setError()
                } else {
                  instance.end = true
                  instance.success = true
                  instance.output = output
                }
              }
            )
          }

          if (this.end && this.success) {
            setTimeout(
              function () {
                vm.csv.target = {
                  filename: `bo-export-surveillances-with-denominators.csv`,
                  blob: new Blob([instance.output], { type: 'text/plain' })
                }
              }, 10)
          }
          return {
            end: this.end,
            success: this.success,
            error: this.error
          }
        },
        setError: function (e) {
          return `Erreur lors de la création du fichier d'export: ${e}`
        }
      }
    ]
    return {
      show: false,
      csv: {
        target: null
      },
      iterator: new StepIterator(steps)
    }
  },

  computed: {
    completed: function () {
      return this.iterator.completed
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    exportAll: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    }
  },

  components: {
    'save-blob': saveBlob,
    'steps': stepsViewer
  }
}
</script>

<style lang="less">
</style>
